
import { VCol } from "vuetify/lib";

export default VCol.extend({});
